import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { FabiJobSearchQueryGenerationUseCase } from '@xing-com/crate-common-graphql-types';
import {
  IconAICareerChanger,
  IconAIProfileSearch,
  IconSalary,
} from '@xing-com/icons';
import { mediaConfined, mediaSmallOrTiny } from '@xing-com/layout-tokens';
import { Marker } from '@xing-com/marker';
import {
  scale090,
  scale110,
  spaceS,
  spaceXS,
  spaceXXS,
} from '@xing-com/tokens';
import { BodyCopy, Meta } from '@xing-com/typography';

const CASES = {
  [FabiJobSearchQueryGenerationUseCase.EarnMore]: {
    title: 'JOBS_SEARCH_AI_SALARY_SUGGESTION',
    subtitle: 'JOBS_SEARCH_AI_SALARY_SUGGESTION_SUBTITLE',
    Icon: IconSalary,
    isNew: false,
  },
  [FabiJobSearchQueryGenerationUseCase.SearchWithProfile]: {
    title: 'JOBS_SEARCH_AI_SWIMP_SUGGESTION',
    subtitle: 'JOBS_SEARCH_AI_SWIMP_SUGGESTION_SUBTITLE',
    Icon: IconAIProfileSearch,
    isNew: false,
  },
  [FabiJobSearchQueryGenerationUseCase.SearchWithSkills]: {
    title: 'JOBS_SEARCH_AI_SWIMS_SUGGESTION',
    subtitle: 'JOBS_SEARCH_AI_SWIMS_SUGGESTION_SUBTITLE',
    Icon: IconAICareerChanger,
    isNew: false,
  },
};

type Props = {
  useCase: FabiJobSearchQueryGenerationUseCase;
};
export const InstantPrompt: React.FC<Props> = ({ useCase }) => {
  const { title, subtitle, Icon, isNew } = CASES[useCase];

  return (
    <Container>
      <StyledIcon as={Icon} />
      <SuggestionText>
        <SuggestionTitle>
          <SuggestionBodyCopy noMargin lineHeight="dense">
            <FormattedMessage id={title} />
          </SuggestionBodyCopy>
          {isNew ? (
            <Marker variant="ai" aria-hidden="true">
              <FormattedMessage id="XDS_FLAG_NEW_NEUTRAL" />
            </Marker>
          ) : null}
        </SuggestionTitle>
        {subtitle ? (
          <SuggestionSubtitle size="small" noMargin>
            <FormattedMessage id={subtitle} />
          </SuggestionSubtitle>
        ) : null}
      </SuggestionText>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  gap: ${spaceS};
  margin-block: -${spaceXS};

  @media ${mediaConfined} {
    gap: 10px;
    margin-block: 0;
  }
`;

const StyledIcon = styled.div`
  flex-shrink: 0;
  width: ${scale090};
  height: ${scale090};

  @media ${mediaConfined} {
    width: ${scale110};
    height: ${scale110};
  }
`;

const SuggestionText = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  gap: ${spaceXXS};
`;

const SuggestionTitle = styled.div`
  display: flex;
  gap: ${spaceXS};
  align-items: start;
  width: 100%;

  @media ${mediaConfined} {
    align-items: center;
  }
`;

const SuggestionBodyCopy = styled(BodyCopy)`
  text-wrap: balance;
`;

const SuggestionSubtitle = styled(Meta)`
  text-wrap: balance;

  @media ${mediaSmallOrTiny} {
    display: none;
  }
`;
